
/* ---------- deep links: ?node= ?t0= ?t1= ?place= ?q= ?preset= ?lanes= ?color= ?scope= ?types=
   Selection survives scrolling and opening advanced controls; nothing resets on its own. ---------- */
(function(){
"use strict";
var PRESETS={
 earliest:{t0:-1520,t1:-200,color:"evidence",scope:"core"},
 ancient:{t0:-900,t1:200},
 classical:{t0:100,t1:900},
 medieval:{t0:800,t1:1450},
 punjab:{q:"punjab",t0:1400,t1:1900,color:"region"},
 encounter:{q:"",t0:1850,t1:1970,color:"region"},
 modern:{t0:1900,t1:2030,lanes:"strand",color:"region"},
 kundalini:{q:"kundalini",t0:1400,t1:2030},
 tibet:{q:"dzogchen",t0:600,t1:1400,color:"region"},
 whole:{t0:-1520,t1:2030,color:"structure",scope:"core"}
};
function setSeg(id,v){
  var seg=document.getElementById(id); if(!seg||!v) return;
  [].forEach.call(seg.children,function(b){b.setAttribute("aria-pressed", String(b.dataset.v===v));});
}
function apply(d,scroll){
  if(typeof S==="undefined") return;
  if(d&&d.preset&&PRESETS[d.preset]) d=Object.assign({},PRESETS[d.preset],d);
  if(d.q!==undefined){var q=String(d.q||"").trim();S.q=q.toLowerCase();S.q0=q;
    var si=document.getElementById("search"); if(si) si.value=q;}
  if(d.t0) S.t0=+d.t0;
  if(d.t1) S.t1=+d.t1;
  if(d.color){S.colorMode=d.color;setSeg("colorMode",d.color);
    if(typeof buildLegend==="function")buildLegend();}
  if(d.scope){S.scope=d.scope;setSeg("scopeMode",d.scope);}
  if(d.lanes){setSeg("laneMode",d.lanes);
    var seg=document.getElementById("laneMode");
    if(seg){var b=seg.querySelector('[data-v="'+d.lanes+'"]'); if(b) b.click();}}
  if(d.types){S.types=new Set(String(d.types).split(","));
    document.querySelectorAll('#connFilters [data-t]').forEach(function(el){
      el.setAttribute("aria-pressed", String(S.types.has(el.dataset.t)));});}
  if(typeof revealAtlas==="function") revealAtlas(false);
  if(window.__syncControls) window.__syncControls();
  if(typeof DB!=="undefined"&&DB){ if(typeof render==="function")render();
    if(typeof renderMinimap==="function")renderMinimap(); }
  if(scroll){var box=document.getElementById("atlasExplorer");
    if(box) box.scrollIntoView({behavior:"smooth",block:"start"});}
}
window.__atlasApply=apply;

/* the guided pathways and the entry presets share one handler */
document.addEventListener("click",function(e){
  var p=e.target.closest(".path,.atlas-preset");
  if(!p) return;
  e.preventDefault();
  var d=Object.assign({}, PRESETS[p.dataset.preset]||{}, p.dataset);
  apply(d,true);
});

function params(){
  var out={}, s=new URLSearchParams(location.search);
  s.forEach(function(v,k){out[k]=v;});
  var h=location.hash.replace(/^#/,"");
  if(/^node-/.test(h)) out.node=h.slice(5);
  return out;
}
function run(){
  var p=params();
  if(p.preset&&PRESETS[p.preset]) Object.assign(p,PRESETS[p.preset]);
  var any=["q","t0","t1","color","scope","lanes","types"].some(function(k){return k in p;});
  if(any) apply(p,false);
  if(p.place&&window.GEOMAP) window.GEOMAP.setPlace(p.place);
  if(p.node&&typeof openPanel==="function"&&typeof BYID!=="undefined"&&BYID[p.node]){
    if(typeof revealAtlas==="function") revealAtlas(false);
    openPanel(p.node);
    var box=document.getElementById("atlasExplorer");
    if(box) box.scrollIntoView({behavior:"smooth",block:"start"});
  }
}
var t=setInterval(function(){
  if(typeof DB!=="undefined"&&DB){clearInterval(t);run();}
},110);
setTimeout(function(){clearInterval(t);},30000);

/* every evidence button also gets a shareable atlas address, without changing what it does */
document.addEventListener("click",function(e){
  var b=e.target.closest("[data-node]");
  if(!b) return;
  if(typeof BYID==="undefined"||!BYID[b.dataset.node]){
    /* this page does not carry that entry — send the reader to the Atlas at it */
    location.href=(window.__ATLAS_URL__||"nonduality-atlas.html")+"?node="+encodeURIComponent(b.dataset.node);
  }
},true);

/* on a phone the advanced control drawers start closed, so the reader is not met by
   a wall of buttons; on a wide screen they are always open and have no summary */
(function(){
  var narrow=window.matchMedia("(max-width:820px)");
  function apply(){ document.querySelectorAll(".ctrldrawer").forEach(function(d){
    if(narrow.matches){ if(!d.dataset.touched) d.open=false; }
    else d.open=true; }); }
  document.querySelectorAll(".ctrldrawer").forEach(function(d){
    d.addEventListener("toggle",function(){ d.dataset.touched="1"; }); });
  apply();
  if(narrow.addEventListener) narrow.addEventListener("change",apply);
})();

/* the depth ladder marks where you are without moving the page */
(function(){
  var links=[].slice.call(document.querySelectorAll(".atlas-depth a"));
  if(!links.length) return;
  var secs=links.map(function(a){return document.querySelector(a.getAttribute("href"));});
  function mark(){
    var y=window.scrollY+180, best=0;
    secs.forEach(function(s,i){ if(s&&s.offsetTop<=y) best=i; });
    links.forEach(function(a,i){ a.classList.toggle("on", i===best); });
  }
  window.addEventListener("scroll",mark,{passive:true}); mark();
})();
})();
